import React from 'react';

const ImpersonateIcon = ({
  className,
  width = '20',
  height = '20'
}: {
  className?: string;
  width?: string;
  height?: string;
}) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.398 10.5971C19.9742 10.5971 25.307 9.7078 25.307 8.61029C25.307 7.87638 22.9127 7.23607 19.3647 6.89391C19.0353 5.36716 18.4133 2.37279 18.0122 1.01717C17.4806 -0.745705 15.5652 0.159078 14.1068 0.930264C12.6486 1.70126 11.8558 0.619169 10.329 0.392233C9.19105 0.233659 8.74016 1.44325 8.74016 1.44325L7.94417 6.83805C4.11046 7.17707 1.4895 7.84242 1.4895 8.61027C1.4895 9.70798 6.82181 10.5973 13.398 10.5973L13.398 10.5971Z"
      fill="#666666"
    />
    <path
      d="M20.7796 21.1905C20.7796 21.1905 22.7974 18.7467 23.1333 17.6584C23.5188 16.4146 18.3357 15.6621 18.3357 15.6621C18.3357 15.6621 17.9906 18.2491 14.4833 19.7042L14.4831 19.7044C13.9189 19.9165 13.2967 19.9165 12.7325 19.7044C9.22825 18.2522 8.81171 15.6747 8.81171 15.6747C8.81171 15.6747 3.69987 16.4084 4.08537 17.6584C4.42127 18.7468 6.43916 21.1905 6.43916 21.1905C2.88203 21.1905 0 23.8055 0 27.0328V27.9999H27.216V27.0328C27.216 23.8053 24.3212 21.1905 20.7798 21.1905L20.7796 21.1905Z"
      fill="#666666"
    />
    <path
      d="M14.5078 11.7644C13.7506 11.8433 12.9871 11.8349 12.2319 11.7396C10.7923 11.2329 7.89441 11.2793 7.89441 12.1251C7.89441 13.2508 9.04171 14.4539 10.4566 14.4539C11.7594 14.4539 12.8227 13.6796 12.9875 12.6786H13.0154C13.248 12.4954 13.5757 12.4954 13.8083 12.6786C13.9731 13.6767 15.0521 14.4508 16.336 14.4508C17.7507 14.4508 18.8982 13.2474 18.8982 12.122C18.9013 11.267 15.9257 11.2328 14.5078 11.7644L14.5078 11.7644Z"
      fill="#666666"
    />
  </svg>
);

export default ImpersonateIcon;
